export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.21-1325.18",
  commitId: "700d5707d7c3ff89ffc4a750a5f9c72ceef9cd4c",
  commitTime: "2026-04-21T13:25:18.000Z",
});
